import { Component, OnInit, HostListener } from '@angular/core';
import { I18nService } from '@app/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs/observable/timer'

import * as CryptoJS from 'crypto-js';

declare var $: any;
declare var OAuth: any
declare var gapi: any
declare var FB: any;

@Component({
  selector: 'app-login-social',
  templateUrl: './login-social.component.html',
  styleUrls: ['./login-social.component.scss']
})
export class LoginSocialComponent implements OnInit {

  title = 'EncryptionDecryptionSample';

  plainText: string = "";
  encryptText: string;
  encPassword: string = "w!z%C*F-JaNdRfUjXn2r5u8x/A?D(G+K"
  decPassword: string = "w!z%C*F-JaNdRfUjXn2r5u8x/A?D(G+K"
  conversionEncryptOutput: string;
  conversionDecryptOutput: string;


  iv: string = ""
  salt = ""
  password: string = ""

  plainToEncrypt: string = ""
  encrypted: string = ""
  passwordToEncrypt: string = ""
  plainFromDecrypt: string = ""
  encryptedToDecrypt: string = ""
  passwordToDecrypt: string = ""

  constructor(
    private api: ApiService
  ) {
    this.api.getCustomAPI("Key", "GetKey")
  }

  async ngOnInit() {
    // let getKeyRes: any = await this.api.getCustomAPI("Key", "GetKey")
    // alert(getKeyRes)
  }

  //method is used to encrypt and decrypt the text  
  convertText(conversion: string) {

    var enKey = CryptoJS.enc.Utf8.parse(this.encPassword.trim());
    var deKey = CryptoJS.enc.Utf8.parse(this.decPassword.trim());

    if (conversion == "encrypt") {
      this.conversionEncryptOutput = CryptoJS.AES.encrypt(this.plainText.trim(), enKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString().trim()
      this.encryptText = this.conversionEncryptOutput
    }
    else {
      this.conversionDecryptOutput = CryptoJS.AES.decrypt(this.encryptText.trim(), deKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8).trim()
    }
  }


  async drosEncrypt() {

    let req = {
      iv: this.iv,
      salt: this.salt,
      password: this.password,
      plainText: this.plainToEncrypt
    }

    let res: any = await this.api.postCustomApi("Dros", "DrosEncrypt", req)
    this.passwordToEncrypt = res.key || ""
    this.encrypted = res.encrypted || ""
  }

  async drosDecrypt() {

    let req = {
      iv: this.iv,
      salt: this.salt,
      password: this.password,
      encrypted: this.encryptedToDecrypt
    }

    let res: any = await this.api.postCustomApi("Dros", "DrosDecrypt", req)
    this.passwordToDecrypt = res.key || ""
    this.plainFromDecrypt = res.encrypted || ""

  }
}



// WEBPACK FOOTER //
// ./src/app/login-social/login-social.component.ts